module.exports = __webpack_public_path__ + "static/bgText-4ba877da32bf9c680c6d7567741160e8.png";